module.exports = __webpack_public_path__ + "mw.3a771f57.svg";